import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AREA, BAR, COLUMN, CUSTOM, DATA_WELL, LINE } from 'reporting-data/constants/chartTypes';
import { getCompare, getDateRangeFilterValue, getDimensions, getReportConfig, isTimeSeriesReport } from 'reporting-data/report/configReportGetters';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { isFunnelReport } from 'reporting-data/tsTypes/reportTypes';
import { getIsMismatchedDimensionDateFilterPropertyTimeSeries } from '../utils';

// @ts-expect-error Untyped import
import { getCompareOptions } from 'reporting-ui-components/lib/compare-options';
import { getUseFiscalYear, isFiscalYearSupportedRangeType } from 'reporting-data/lib/fiscalYearUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const NO_COMPARE = 'NO_COMPARE';
export const getCompareOptionsForDropdown = (report, options) => {
  const config = getReportConfig(report);
  const compare = getCompare(config);
  const dateRange = getDateRangeFilterValue(config);
  const useFiscalYear = getUseFiscalYear(config) && isFiscalYearSupportedRangeType(dateRange.get('rangeType'));
  const compareOptions = getCompareOptions({
    dateRange,
    explicit: options === null || options === void 0 ? void 0 : options.explicit,
    compare,
    useFiscalYear
  });
  return [{
    value: NO_COMPARE,
    text: I18n.text('report-customization-components.customization-components.comparison-dropdown.config.options.noComparison')
  }, ...compareOptions];
};
export const getToolTipText = report => {
  const chartType = getReportChartType(report);
  const dimensions = getDimensions(report);
  const isValidChartType = [LINE, AREA].includes(chartType) && isTimeSeriesReport(report) && (dimensions === null || dimensions === void 0 ? void 0 : dimensions.size) < 2 || [BAR, COLUMN].includes(chartType) && (dimensions === null || dimensions === void 0 ? void 0 : dimensions.size) < 2 || [DATA_WELL, CUSTOM].includes(chartType);
  if (getIsMismatchedDimensionDateFilterPropertyTimeSeries(report)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.comparison-dropdown.config.tooltip.mismatchProperties"
    });
  } else if (!isValidChartType) {
    if (dimensions.size > 1) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.comparison-dropdown.config.tooltip.multiDimensional"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.comparison-dropdown.config.tooltip.unavailable"
    });
  } else if (isFunnelReport(report)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.comparison-dropdown.config.tooltip.funnel"
    });
  }
};